import { useCallback, useState } from 'react';
import apiProxyService from '../../infrastructure/api/ApiProxyService';

/**
 * API işlemlerini yönetmek için hook
 */
export function useApi() {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /**
   * API isteği yürütme fonksiyonu
   * @param apiCall API çağrısı yapacak fonksiyon
   * @returns API yanıtı
   */
  const executeRequest = useCallback(async <T>(apiCall: () => Promise<T>): Promise<T> => {
    setIsLoading(true);
    try {
      const response = await apiCall();
      return response;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    executeRequest,
    apiProxyService
  };
} 